import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "MTST";
const SITE_URL = "https://www.mtstech.kr";

// 실제 서비스 도메인이 아닌 곳(개발/스테이징 서버 등)에서는
// 검색엔진이 실수로 색인하지 않도록 noindex를 자동으로 붙인다.
const isProductionHost =
  typeof window !== "undefined" &&
  window.location.hostname.replace(/^www\./, "") === "mtstech.kr";

// OG/트위터 카드는 지금 실제로 열려있는 도메인 기준으로 만든다.
// (개발서버에서 링크를 공유해도 미리보기 이미지가 그 서버 주소로 정상 로드되도록)
const currentOrigin =
  typeof window !== "undefined" ? window.location.origin : SITE_URL;

const Seo = ({ title, description, path = "/", image }) => {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const canonicalUrl = `${SITE_URL}${path}`;
  const ogUrl = `${currentOrigin}${path}`;
  const ogImage = image || `${currentOrigin}/mtst-logo.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta
        name="robots"
        content={isProductionHost ? "index, follow" : "noindex, nofollow"}
      />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="ko_KR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
